
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { INVENTORY_SUB_TABS, RETURNS_SUB_TABS } from "../../../constants/globalConstants";

export const useInventoryState = () => {
  const [inventory, setInventoryState] = useState([]);
  const [materialRequests, setMRState] = useState([]);
  const [materialReturns, setReturnsState] = useState([]);
  const [sales, setSalesState] = useState([]);
  const [purchaseReturns, setPurchaseReturnsState] = useState([]);
  const [purchases, setPurchases] = useState([]);
  const [openingStocks, setOpeningStocks] = useState([]);
  const [damagedItems, setDamagedItemsState] = useState([]);
  const [projectsLocal, setProjectsLocal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // Dynamic Settings States
  const [cats, setCats] = useState([]);
  const [units, setUnits] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [brands, setBrands] = useState([]);
  const [stores, setStores] = useState([]);
  const [masterItems, setMasterItems] = useState([]);
  const [subCats, setSubCats] = useState([]);

  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);
  const initialProject = "Verve";

  const [activeTab, setActiveTab] = useState(initialProject);
  const [viewMode, setViewMode] = useState("requests");
  const [blumTab, setBlumTab] = useState("purchases");
  const [inventorySubTab, setInventorySubTab] = useState(INVENTORY_SUB_TABS.PURCHASES);
  const [returnsSubTab, setReturnsSubTab] = useState(RETURNS_SUB_TABS.MASTER);

  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    category: "all",
    subCategory: "all",
    supplier: "all",
    status: "all",
    date: "all",
    fromDate: "",
    toDate: ""
  });
  const [sortBy, setSortBy] = useState("newest");

  const [addOpen, setAddOpen] = useState(false);
  const [restockItem, setRestockItem] = useState(null);
  const [restockQty, setRestockQty] = useState("");
  const [restockReturn, setRestockReturn] = useState(null);
  const [editingItem, setEditingItem] = useState(null);
  
  const [selReq, setSelReq] = useState(null);
  const [selReturn, setSelReturn] = useState(null);
  const [saleOpen, setSaleOpen] = useState(false);
  const [purchaseOpen, setPurchaseOpen] = useState(false);
  const [purchaseReturnOpen, setPurchaseReturnOpen] = useState(false);
  const [saleReturnOpen, setSaleReturnOpen] = useState(false);
  const [openStockOpen, setOpenStockOpen] = useState(false);
  const [selSale, setSelSale] = useState(null);
  const [selPR, setSelPR] = useState(null);
  const [selSR, setSelSR] = useState(null);
  const [initialReturnInvoice, setInitialReturnInvoice] = useState("");
  const [selectedPRForPayment, setSelectedPRForPayment] = useState(null);
  const [selectedSRForPayment, setSelectedSRForPayment] = useState(null);
  const [dispatchReq, setDispatchReq] = useState(null);
  const [viewItem, setViewItem] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [editingOpenStock, setEditingOpenStock] = useState(null);

  return {
    inventory, setInventoryState,
    materialRequests, setMRState,
    materialReturns, setReturnsState,
    sales, setSalesState,
    purchaseReturns, setPurchaseReturnsState,
    purchases, setPurchases,
    openingStocks, setOpeningStocks,
    damagedItems, setDamagedItemsState,
    projectsLocal, setProjectsLocal,
    loading, setLoading,
    cats, setCats,
    subCats, setSubCats,
    units, setUnits,
    suppliers, setSuppliers,
    brands, setBrands,
    stores, setStores,
    masterItems, setMasterItems,
    activeTab, setActiveTab,
    viewMode, setViewMode,
    blumTab, setBlumTab,
    inventorySubTab, setInventorySubTab,
    returnsSubTab, setReturnsSubTab,
    search, setSearch,
    filters, setFilters,
    sortBy, setSortBy,
    addOpen, setAddOpen,
    restockItem, setRestockItem,
    restockQty, setRestockQty,
    restockReturn, setRestockReturn,
    editingItem, setEditingItem,
    selReq, setSelReq,
    selReturn, setSelReturn,
    saleOpen, setSaleOpen,
    purchaseOpen, setPurchaseOpen,
    purchaseReturnOpen, setPurchaseReturnOpen,
    saleReturnOpen, setSaleReturnOpen,
    openStockOpen, setOpenStockOpen,
    selSale, setSelSale,
    selPR, setSelPR,
    selSR, setSelSR,
    initialReturnInvoice, setInitialReturnInvoice,
    selectedPRForPayment, setSelectedPRForPayment,
    selectedSRForPayment, setSelectedSRForPayment,
    dispatchReq, setDispatchReq,
    viewItem, setViewItem,
    isExpanded, setIsExpanded,
    editingOpenStock, setEditingOpenStock,
    submitting, setSubmitting
  };
};
